const returnColorCode = (Color) => {
  let chapterColor;
  switch(Color) {
    case 'secondary___cyan':
      chapterColor = 'cyan';
      break;
    case 'secondary___purple':
      chapterColor = 'purple';
      break;
    case 'secondary___green':
      chapterColor = 'green';
      break;
    case 'secondary___grey':
      chapterColor = 'grey';
      break;
    case 'primary___red':
      chapterColor = 'red';
      break;
  }
  return chapterColor;
};

exports.returnColorCode = returnColorCode;
